import { jsx as _jsx } from "react/jsx-runtime";
import "core-js/proposals/map-upsert-v4";
import { memo, useEffect } from "react";
import { Provider } from "react-redux";
import { StyleEditorSidebar } from "./components/StyleEditorSidebar.js";
import { store } from "./store.js";
import { initStyle } from "./reducers/historyEnhancer.js";
import { StyleEditorMap } from "./components/StyleEditorMap.js";
import { setMapkaApiKey } from "./reducers/apiKeyReducer.js";
import { StyleEditorProvider } from "./components/StyleEditorContext.js";
import { IntlProvider } from "./components/IntlProvider.js";
import { setExtraSpec } from "./utils/actions.js";
import { SplitPanel } from "./components/SplitPanel.js";
import { StyleEditorShell } from "./components/StyleEditorShell.js";
import { useInitializeInStoreDuringRender } from "./hooks/redux.js";
import { StyleEditorDiffMap } from "./components/StyleEditorDiffMap.js";
import { QueryProvider } from "./components/QueryProvider.js";
import { useChatSubscription } from "./hooks/useChatSubscription.js";
import { useChatChangeStore } from "./hooks/useChatChangeStore.js";
import { useChatStoreState } from "./hooks/useChatStoreState.js";
export const StyleEditorInner = memo(({ style, view, mapkaApiKey, mapkaAccountName, locale, extraSpec, mode, chatId, featureFlags, captureEvent, onLoad, onSaveStyle, onPublishStyle, onCreateStyle, onViewChange, onChatChange, onNavigateBack, onShare, }) => {
    /**
     * Order of these is important, if api key is not populated then sourcesMiddleware will not work properly
     */
    useInitializeInStoreDuringRender(setMapkaApiKey, mapkaApiKey);
    useInitializeInStoreDuringRender(initStyle, style);
    useInitializeInStoreDuringRender(setExtraSpec, extraSpec);
    useChatSubscription(style.style.id);
    const { changeChat } = useChatChangeStore(style.style.id);
    const { initialized } = useChatStoreState(style.style.id);
    useEffect(() => {
        if (chatId && initialized)
            changeChat(chatId);
    }, [initialized, chatId]);
    useEffect(() => {
        onLoad?.();
    }, []);
    const StyleEditorMapComp = view === "versions" ? StyleEditorDiffMap : StyleEditorMap;
    return (_jsx(IntlProvider, { locale: locale, children: _jsx(Provider, { store: store, children: _jsx(StyleEditorProvider, { mapkaAccountName: mapkaAccountName, captureEvent: captureEvent, featureFlags: featureFlags, onChatChange: onChatChange, mode: mode, children: _jsx(StyleEditorShell, { view: view, onViewChange: onViewChange, onNavigateBack: onNavigateBack, onSave: onSaveStyle, onPublish: onPublishStyle, onCreate: onCreateStyle, onShare: onShare, children: _jsx(SplitPanel, { view: view, onViewChange: onViewChange, leftPanel: (_jsx(StyleEditorSidebar, { view: view, onViewChange: onViewChange })), rightPanel: (_jsx(StyleEditorMapComp, { view: view })) }) }) }) }) }));
});
StyleEditorInner.displayName = "StyleEditor";
export const StyleEditor = memo((props) => {
    return (_jsx(QueryProvider, { children: _jsx(StyleEditorInner, { ...props }) }));
});
